import React, { Suspense } from 'react';
import { Route } from '@americanexpress/one-app-router';
import { CenteredProgressCircular } from '@americanexpress/virtual-cards-commons';
import requireValidSession from './hooks/requireValidSession';
import { ROUTE } from './utils/constants';
import updateShallowIdentitySession from './hooks/updateShallowIdentitySession';

const Dashboard = React.lazy(() => import('./components/pages/dashboard/Dashboard'));
const Invite = React.lazy(() => import('./components/pages/invite/Invite'));
const Registration = React.lazy(() => import('./components/pages/registration/Registration'));
const ProductEligibility = React.lazy(() => import('./components/pages/eligibility/ProductEligibility'));
const Profile = React.lazy(() => import('./components/pages/profile/Profile'));
const Error = React.lazy(() => import('./components/pages/error/Error'));
const FreezeCard = React.lazy(() => import('./components/pages/cardManagement/FreezeCard'));

// eslint-disable-next-line eslint-comments/disable-enable-pair -- -r
/* eslint-disable react/jsx-key -- -r */
const childRoutes = (store) => [
  <Route
    path={ROUTE.DASHBOARD}
    onEnter={requireValidSession(store)}
    component={() => (
      <Suspense fallback={<CenteredProgressCircular showFullPage={true} />}>
        <Dashboard />
      </Suspense>
    )}
  />,
  <Route
    path={ROUTE.INVITE}
    component={() => (
      <Suspense fallback={<CenteredProgressCircular showFullPage={true} />}>
        <Invite />
      </Suspense>
    )}
  />,
  <Route
    path={ROUTE.REGISTRATION}
    onEnter={updateShallowIdentitySession(store)}
    component={() => (
      <Suspense fallback={<CenteredProgressCircular showFullPage={true} />}>
        <Registration />
      </Suspense>
    )}
  />,
  <Route
    path={ROUTE.ELIGIBILITY}
    onEnter={requireValidSession(store)}
    component={() => (
      <Suspense fallback={<CenteredProgressCircular showFullPage={true} />}>
        <ProductEligibility />
      </Suspense>
    )}
  />,
  <Route
    path={ROUTE.PROFILE}
    onEnter={updateShallowIdentitySession(store)}
    component={() => (
      <Suspense fallback={<CenteredProgressCircular showFullPage={true} />}>
        <Profile />
      </Suspense>
    )}
  />,
  <Route
    path={ROUTE.ERROR}
    component={() => (
      <Suspense fallback={<CenteredProgressCircular showFullPage={true} />}>
        <Error />
      </Suspense>
    )}
  />,
  <Route
    path={ROUTE.FREEZE_CARD}
    onEnter={requireValidSession(store)}
    component={() => (
      <Suspense fallback={<CenteredProgressCircular />}>
        <FreezeCard />
      </Suspense>
    )}
  />,
  <Route
    path="*"
    onEnter={(nextState, replace) => {
      replace({ pathname: ROUTE.ERROR, query: { errorType: 'not_found' } });
    }}
  />,
];

export default childRoutes;
